
// Open a modal.
export const openModal = (targetId, content) => {
  const modal = document.getElementById(targetId);
  if (modal) {
    modal.setAttribute('aria-hidden', 'false');
    // Focus the first element within the modal.
    const focusable_selectors = 'a[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), *[tabindex]';
    modal.querySelector(focusable_selectors).focus();
    // Make the body unscrollable.
    document.body.classList.add('disabled');
  }
}

// Scroll to element using gsap (loaded in Core)
export const scrollTo = (options) => {
  if (window.gsap) {
    window.gsap.to(window, {
      duration: .5,
      scrollTo: options
    });
  } else {
    console.error('gsap is not found in scrollTo()');
  }
}

// Convert text to title case.
export const titleCase = (str) => {
  if (!str) return;
  return str.toLowerCase().split(' ').map(function(word) {
      return (word.charAt(0).toUpperCase() + word.slice(1));
  }).join(' ');
}
